import { RouterLink } from '@angular/router';
import { Component, QueryList, ContentChildren, Input,
  forwardRef, ContentChild, AfterContentInit, Output, EventEmitter
} from '@angular/core';

@Component({
  selector: 'pui-menu',
  template: `
    <li *ngIf="title" [ngClass]="getHeadingClasses()">
      <h3 class="uppercase">
        <i *ngIf="icon" class="{{ icon }}"></i>
        <span>{{ title }}</span>
      </h3>
    </li>
    <ng-content></ng-content>
  `
})
export class PuiMenuComponent implements AfterContentInit {
  @Input() title: string;
  @Input() icon: string;

  @ContentChildren(forwardRef(() => PuiMenuItemComponent)) items: QueryList<PuiMenuItemComponent>;

  private _visible = true;
  set visible(visible: boolean) {
    this._visible = visible;
  }
  get visible() {
    return this._visible;
  }

  getHeadingClasses(): any {
    return {
      'heading': true,
      'hidden': !this.visible
    };
  }

  ngAfterContentInit(): void {
    this.visible = this.items.length > 0 && this.items.some(item => item.visible);
  }
}

@Component({
  selector: 'pui-menu-item',
  template: `
    <li routerLinkActive="active" [ngClass]="getClasses()">
      <ng-container *ngIf="!group">
        <ng-container *ngIf="href">
          <a class="nav-link" [attr.href]="href" [attr.target]="target">
            <i *ngIf="icon" class="{{ icon }}"></i>
            <span class="title">{{ title }}</span>
          </a>
        </ng-container>
        <ng-container *ngIf="!href">
          <a class="nav-link" [routerLink]="path">
            <i *ngIf="icon" class="{{ icon }}"></i>
            <span class="title">{{ title }}</span>
          </a>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="group">
        <a [ngClass]="getToggleClasses()">
          <i *ngIf="icon" class="{{ icon }}"></i>
          <span class="title">{{ title }}</span>
          <span class="arrow"></span>
        </a>
        <ul class="sub-menu">
          <ng-content></ng-content>
        </ul>
      </ng-container>
    </li>
  `
})
export class PuiMenuItemComponent implements AfterContentInit {
  @Input() title: string;
  @Input() path: RouterLink;
  @Input() icon: string;
  @Input() metadata: string;
  @Input() href: string;
  @Input() target = '_blank';

  @Output() click = new EventEmitter<any>();

  @ContentChild(forwardRef(() => PuiItemGroupComponent)) group: PuiItemGroupComponent;

  private _visible = true;
  set visible(visible: boolean) {
    this._visible = visible;
  }
  get visible() {
    return this._visible;
  }

  getClasses(): any {
    return {
      'nav-item': true,
      'hidden': !this.visible
    };
  }

  getToggleClasses(): any {
    return {
      'nav-link': true,
      'nav-toggle': this.group ? true : false
    };
  }

  ngAfterContentInit(): void {
    this.visible = !this.group || this.group.items.length > 0;
  }
}

@Component({
  selector: 'pui-item-group',
  template: '<ng-content></ng-content>'
})
export class PuiItemGroupComponent {
  @ContentChildren(PuiMenuItemComponent) items: QueryList<PuiMenuItemComponent>;
}
